import { useEffect } from "react";
import { createContext, useReducer } from "react";
import { themeKeys } from "../../constants/themes";
import { changeFavicon } from "../../utils/changeFavicon";
import { reducer } from "./reducer";

export const AppContext = createContext({});

const getCurrentTheme = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches;

const initialState = {
  music: { isPlaying: false, song: null, volume: 1 },
  hovered: [],
  selectedObject: null,
  drawer: {
    isOpen: false,
    position: "right",
    content: null,
    handleClose: null,
  },
  theme: getCurrentTheme() ? themeKeys.DARK : themeKeys.LIGHT,
};

export default function AppContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    changeFavicon(state.theme);
  }, [state.theme]);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}
